import React from 'react'
import { RouterProvider } from 'react-router-dom';
import { APIProvider as GoogleMapsAPIProvider } from '@vis.gl/react-google-maps';
import { Provider } from 'react-redux';
import { ToastContainer } from '@myhealth-raccoon/components';

import { MessageProvider } from './contexts/message';
import { ModalProviders } from './contexts/ModalProviders';
import { store } from 'src/store';
import { router } from './router';
import { LoadingScreen } from './components/screens/LoadingScreen';

function App() {
  return (
    <GoogleMapsAPIProvider apiKey={import.meta.env.VITE_MAPS_API_KEY}>
      <MessageProvider>
        <Provider store={store}>
          <ModalProviders>
            <RouterProvider fallbackElement={<LoadingScreen />} router={router} />
            <ToastContainer />
          </ModalProviders>
        </Provider>
      </MessageProvider>
    </GoogleMapsAPIProvider>
  )
}

export default App
